export default __webpack_public_path__ + "assets/ef90e3b29493b8a40c6302214c6e3ed7.jpg";